import {createContext, useContext, useMemo} from 'react';
import {assert} from 'assert-ts';
import type {Data, Schema} from 'schemaDefinition/types';

export type PreviewSchemaScopeContextType = {
  schema: Schema;
  values: Data;
};

export const PreviewSchemaGlobalScopeContext = createContext<
  PreviewSchemaScopeContextType | undefined
>(undefined);

export const usePreviewSchemaGlobalScopeContextProviderValue = (
  schema: Schema,
  values: Data,
): PreviewSchemaScopeContextType =>
  useMemo(
    () => ({
      schema,
      values,
    }),
    [schema, values],
  );

export const usePreviewSchemaGlobalScopeContext =
  (): PreviewSchemaScopeContextType => {
    return assert(
      useContext(PreviewSchemaGlobalScopeContext),
      'usePreviewSchemaGlobalScopeContext: context expected',
    );
  };

export const PreviewSchemaLocalScopeContext = createContext<
  PreviewSchemaScopeContextType | undefined
>(undefined);

export const usePreviewSchemaLocalScopeContext =
  (): PreviewSchemaScopeContextType => {
    return assert(
      useContext(PreviewSchemaLocalScopeContext),
      'usePreviewSchemaLocalScopeContext: context expected',
    );
  };
